import { ref, watch } from 'vue'

const savedLang = localStorage.getItem('lang')
const lang = ref(savedLang || 'fa')
const dir = ref(lang.value === 'fa' ? 'rtl' : 'ltr')

watch(
  lang,
  (value) => {
    const newDir = value === 'fa' ? 'rtl' : 'ltr'

    if (localStorage.getItem('lang') !== value) {
      localStorage.setItem('lang', value)
    }

    // فقط در صورت تغییر، DOM را آپدیت کن
    if (dir.value !== newDir) {
      dir.value = newDir
    }

    if (document.documentElement.dir !== newDir) {
      document.documentElement.dir = newDir
    }

    if (document.documentElement.lang !== value) {
      document.documentElement.lang = value
    }
  },
  { immediate: true }
)

const setLang = (value) => {
  if (lang.value !== value) {
    lang.value = value
  }
}

export { lang, dir, setLang }
